import React from 'react';
import { connect } from 'react-redux';
import Translate from 'translate';
import { Form } from 'react-form';
import moment from 'moment';
import Table from 'components/HTMLElements/Table/Custom';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import ReportService from 'services/ReportService';
import { FormGroup, InputDate } from 'components/FormElements';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/file/file-download';
import MenuItem from 'material-ui/MenuItem';
class ExecutiveSummaryReport extends React.Component {
  constructor(props) {
    super(props);
    this.date = new Date();
    this.firstDay = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
    this.state = {
      data: [],
      dateFrom: this.firstDay,
      dateTo: new Date(),
      deleteModalOpened: false
    };
    this.download = '';
    this.search = {};
    this.getData = this.getData;
  }
  componentDidMount() {
    this.getReport(this.params);
  }
  getReport(params) {
    const { isLoading, toggleLoading } = this.props;
    this.params = _.cloneDeep(params);

    if (!isLoading) toggleLoading(true);
    const apiParams = {
      from: moment(this.state.dateFrom).format('YYYY-MM-DD') ,
      to: moment(this.state.dateTo).format('YYYY-MM-DD') 
    };
    if (this.download !== '' ) {
      apiParams.download = this.download
    }
    ReportService.getReportsService(apiParams).then(response => {
      
      if (this.download !== '') {
        toggleLoading(false);
        window.location.href = response.data.uri;
      } else {

        if (response.data) {
          this.setState({
            data: response.data
          });
        }
        toggleLoading(false);
      }
    });
  }

  handleDateChangeDateFrom = e => {
    this.setState({ dateFrom: e });
  };

  handleDateChangeDateTo = e => {
    this.setState({ dateTo: e });
  };

  submitForm = data => {
    this.search = data;
    //this.getReport(this.params);
  };

  render() {
    const { data, dateFrom, dateTo } = this.state;
    return (
      <div className="box box-default">
        <div className="box-header d-flex justify-content-between">
          <h4>
            <Translate id="report.uptimeReport" />
          </h4>
        </div>
        <div>
          <Form onSubmit={this.submitForm}>
            {({ submitForm }) => (
              <form onSubmit={submitForm} className="d-flex">
                <FormGroup containerClass="col-md-3">
                  <InputDate
                    label={<Translate id="report.dateFrom" />}
                    value={dateFrom}
                    onChange={this.handleDateChangeDateFrom}
                  />
                </FormGroup>

                <FormGroup containerClass="col-md-3">
                  <InputDate
                    label={<Translate id="report.dateTo" />}
                    value={dateTo}
                    onChange={this.handleDateChangeDateTo}
                  />
                </FormGroup>

                <div className="col-md-2 pl-0">
                  <button
                    style={{ marginTop: '15px', marginLeft: '-50px' }}
                    type="submit"
                    className="btn btn-info mr-2 px-3"
                    onClick={() => {
                      this.search = {};
                      this.download = '';
                      this.getReport(
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                  >
                    <i className="fa fa-search pointer" />
                  </button>
                </div>

                <div className="col-md-4 pl-0 text-right">


                  <IconMenu style={{ height: '20px' }}
                        iconButtonElement={
                          <IconButton touch className="btn-account">
                            <NavigationExpandMoreIcon/>
                          </IconButton>
                        }>
                  <MenuItem
                    onClick={() => {
                      this.search = {};
                      this.download = 'excel';
                      this.getReport(
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                    key={1}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={''}> 
                    <i className="fa fa-file-excel-o pointer" /> CSV 
                  </MenuItem>
                  {/*<MenuItem
                    onClick={() => {
                      this.search = {};
                      this.download = 'pdf';
                      this.getReport(
                        value,
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                    key={2}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={''}> 
                    <i className="fa fa-file-pdf-o pointer" /> Pdf
                  </MenuItem>
                  */}
                  </IconMenu>
                </div>
              </form>
            )}
          </Form>
          <div className="box-body">
            <Table
              className="app-table-report"
              data={data}
              columns={[
                {
                  Header: <Translate id="date" />,
                  accessor: 'date'
                },
                {
                  Header: 'Database',
                  columns: [
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="fails" />
                        </div>
                      ),
                      accessor: "db_status_incidents",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_hour" />
                        </div>
                      ),
                      accessor: "db_status_availableTime",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_percent" />
                        </div>
                      ),
                      accessor: "db_status_percent",
                      Cell: (props) => <div className={ props.value <= 98 ? "text-center color-danger"  : "text-center color-success"}> {props.value} </div>,
                    },
                  ]
                },
                
                {
                  Header: 'External API',
                  columns: [
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="fails" />
                        </div>
                      ),
                      accessor: "incms_status_incidents",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_hour" />
                        </div>
                      ),
                      accessor: "incms_status_availableTime",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_percent" />
                        </div>
                      ),
                      accessor: "incms_status_percent",
                      Cell: (props) => <div className={ props.value <= 98 ? "text-center color-danger"  : "text-center color-success"}> {props.value} </div>,
                    },
                  ]
                },
                
                {
                  Header: 'Facebook',
                  columns: [
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="fails" />
                        </div>
                      ),
                      accessor: "facebook_status_incidents",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_hour" />
                        </div>
                      ),
                      accessor: "facebook_status_availableTime",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_percent" />
                        </div>
                      ),
                      accessor: "facebook_status_percent",
                      Cell: (props) => <div className={ props.value <= 98 ? "text-center color-danger"  : "text-center color-success"}> {props.value} </div>,
                    },
                  ]
                },
                {
                  Header: 'Twitter',
                  columns: [
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="fails" />
                        </div>
                      ),
                      accessor: "twitter_status_incidents",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_hour" />
                        </div>
                      ),
                      accessor: "twitter_status_availableTime",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_percent" />
                        </div>
                      ),
                      accessor: "twitter_status_percent",
                      Cell: (props) => <div className={ props.value <= 98 ? "text-center color-danger"  : "text-center color-success"}> {props.value} </div>,
                    },
                  ]
                },
                {
                  Header: 'Email',
                  columns: [
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="fails" />
                        </div>
                      ),
                      accessor: "email_status_incidents",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_hour" />
                        </div>
                      ),
                      accessor: "email_status_availableTime",
                      Cell: (props) => <div className="text-center"> {props.value} </div>,
                    },
                    {
                      Header: (
                        <div className="text-center">
                          <Translate id="uptime_percent" />
                        </div>
                      ),
                      accessor: "email_status_percent",
                      Cell: (props) => <div className={ props.value <= 98 ? "text-center color-danger"  : "text-center color-success"}> {props.value} </div>,
                    },
                  ]
                },
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.settings.isLoading
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: message => {
    dispatch(toggleAlertError(message));
  },
  toggleLoading: isLoading => {
    dispatch(toggleLoading(isLoading));
  }
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExecutiveSummaryReport);



// WEBPACK FOOTER //
// ./routes/app/routes/reports/UptimeReport/index.js